import type { ExtensionConfig } from '@goto/shell'
import { getLaunchDarklyFlag } from '../helpers/shell-helpers'
import { LaunchDarklyVariations } from '../models/feature-flag.models'
import { getOOSArtifactUrl } from '../helpers/experience-helpers'

const extensionConfig: ExtensionConfig = {
  id: '@goto/oos-meeting-meet-now',
  get url() {
    const version = getLaunchDarklyFlag(LaunchDarklyVariations.OOS_MEET_NOW_VERSION)
    return new URL(getOOSArtifactUrl('meeting-meet-now-extension', version))
  },
}

export default extensionConfig
